import { toggleConfirmationPopup } from 'actions/placeorder';
import { MARGIN_TYPES } from 'constants/constants';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import {
  alwaysShowOnMobileSelector,
  appDrawerSelector,
  fatFingerProtectionSelector,
  marketOrderUserPreferenceSelector,
  orderPlacedFromChartsSelector,
  userMarginModeSelector,
} from 'selectors/otherSelectors';
import {
  impactSizeErrorSelector,
  isFormValidSelector,
  quantityInputDropdownValue,
  quantityInputValueInContract,
  sideSelection,
  slippageCheckSelector,
} from 'selectors/placeOrderSelector';

import submitOrder from '../ConfirmationModals/orderSubmit.thunk';
import getMarginPortfolio from '../MarginComponent/marginPortfolioThunk';
import handleError from '../QuantityInput/handleErrors.thunk';

const submitThunk = () => (dispatch, getState) => {
  const state = getState();
  const isFormValid = isFormValidSelector(state);
  const selectedDropdown = quantityInputDropdownValue(state);
  const side = sideSelection(state);
  if (!isFormValid) {
    const value = quantityInputValueInContract(state);
    dispatch(handleError(value, selectedDropdown, side, true));
    return false;
  }
  const showConfirmation = marketOrderUserPreferenceSelector(state);
  const showFatFingers = fatFingerProtectionSelector(state);
  const alwaysShowOnMobile = alwaysShowOnMobileSelector(state);
  const orderFromChart = orderPlacedFromChartsSelector(state);
  const { activeTab } = appDrawerSelector(state);
  const marginMode = userMarginModeSelector(state);

  const slippageCheckError = slippageCheckSelector(state);
  const impactSizeError = impactSizeErrorSelector(state);

  if (!orderFromChart && activeTab === APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK) {
    dispatch(submitOrder());
    return true;
  }

  if (
    showConfirmation ||
    (showFatFingers && (impactSizeError || slippageCheckError)) ||
    (window.innerWidth <= 640 && alwaysShowOnMobile)
  ) {
    if (marginMode === MARGIN_TYPES.PORTFOLIO && orderFromChart) {
      dispatch(getMarginPortfolio());
    }
    dispatch(toggleConfirmationPopup(true));
  } else {
    dispatch(submitOrder());
  }
  return true;
};

export default submitThunk;
